export default "__VITE_ASSET__$fQxfs6N__"